import { PageLayout } from "@/components/layout/PageLayout";
import { TreeViewProvider } from "@/components/layout/TreeViewShell";
import { WorkspaceSidebar } from "@/components/layout/WorkspaceSidebar";
import { Toaster } from "sonner";
import { Outlet } from "react-router-dom";

/**
 * App chrome for left-rail routes — top NavBar + persistent WorkspaceSidebar.
 * Mount once as a React Router layout route; feature layouts only add content /
 * right panels into the Outlet. TreeViewProvider sits here so the sidebar's
 * Clipboard section and the routed clipboard page share one selection state.
 * The Toaster is app-wide so toast() calls fire on every route, not just chat.
 */
export const AppShell = () => (
  <TreeViewProvider>
    <PageLayout
      sidebarId="workspace-sidebar"
      sidebarLabel="Workspace navigation"
      leftSidebar={<WorkspaceSidebar />}
    >
      <Outlet />
    </PageLayout>
    <Toaster position="bottom-right" richColors />
  </TreeViewProvider>
);
